import type { UsersMeSettingsResponseBody } from '@ipfabric/utils';
import {
  customNodeTypeTableSettings,
  customTableSettingsNodeTypes,
  getCloudConstructDefaultTables,
} from '../../helpers/customNodeTableSettings';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';
import { showTable } from './showTable';

export const loadDeviceViewSettings: DeviceViewCommandFactory =
  (cmdContext, dispatch) => async () => {
    const deviceViewSettings =
      await cmdContext.api.request<UsersMeSettingsResponseBody>({
        url: '/users/me/settings',
        method: 'GET',
      });

    if (deviceViewSettings.diagrams) {
      const { pathsWithName } = cmdContext.getState();
      cmdContext.updateState((draft) => {
        draft.settings.nodes =
          deviceViewSettings.diagrams?.tableSetup?.nodes ?? {};
        for (const nodeType of customTableSettingsNodeTypes) {
          // Cloud constructs resolve their labels from the OAS at apply
          // time (NIM-24243) so the tab titles track the YAML
          // `x-table.title` / route `post.summary`. Non-cloud overrides
          // (`fex`, `host`, ...) keep their hardcoded labels because the
          // YAML summary doesn't match the UI text we want.
          const cloudTables = getCloudConstructDefaultTables(
            nodeType,
            pathsWithName,
          );
          // When cloud tables don't apply (non-cloud node type, or
          // ENABLE_NEW_CLOUD_MODEL disabled - NIM-24373) and there is no
          // hardcoded override either, keep whatever was already loaded
          // from the user's saved table setup instead of wiping it out.
          draft.settings.nodes[nodeType] =
            cloudTables ??
            customNodeTypeTableSettings[nodeType] ??
            draft.settings.nodes[nodeType];
        }
        draft.settings.nodesLoaded = true;
      });
    }

    const { deviceViewEntities } = cmdContext.getState();
    for (const deviceViewEntity of deviceViewEntities) {
      if (
        deviceViewEntity?.deviceViewElement === 'node' &&
        deviceViewEntity.redirectToTable !== undefined
      ) {
        dispatch(showTable, {
          deviceViewEntityId: deviceViewEntity.id,
          webEndpoint: deviceViewEntity.redirectToTable,
        });
      }
    }
  };
